import { Endpoint } from '@business/api/endpoint';
import { Paginate } from '@business/entities/common';
import { PCompanyRequest, PCompanyResponse, PHACategoryResponse } from '@business/entities/frontend';
import { FormValueResponse } from '@business/entities/file';
import {
  FilteredHelpArticleResponse,
  PHACategoryRequest,
  PHARequest,
  PHelpArticleResponse,
  PSearchRequest,
  PFormRequest,
} from './../../entities/frontend/FrontendResponse';
import { PublicFormsResponse } from '@business/entities/frontend/Forms';

export function filterArticles(params: PSearchRequest) {
  return Endpoint.get<Paginate<FilteredHelpArticleResponse>>(`@gc/public/filter-articles`, { params });
}

export function fetchCompanyData(params: PCompanyRequest) {
  return Endpoint.get<PCompanyResponse>(`@gc/public/company-data`, { params });
}

export function fetchPublicHACategories(params: PHACategoryRequest) {
  return Endpoint.get<PHACategoryResponse>(`@gc/public/category-data`, { params });
}

export function fetchPublicHelpArticle(params: PHARequest) {
  return Endpoint.get<PHelpArticleResponse>(`@gc/public/help-article-data`, { params });
}

export function fetchPublicForm(fileId: string) {
  return Endpoint.get<FormValueResponse>(`@gc/form/${fileId}`, {});
}

export function fetchPublicFormShare(shareId: string) {
  return Endpoint.get<FormValueResponse>(`@gc/public/form/form-share/${shareId}`);
}

export function saveFormValues(id: string, values: string, type = 'form') {
  return Endpoint.post<FormValueResponse>(`@gc/form/save-values/${id}`, { data: { values, type } });
}

export function fetchForms() {
  return Endpoint.get<PublicFormsResponse[]>(`@gc/client-forms`, {});
}

// export function fetchCompanyData(params: HelpArticlesPublicRequest) {
//   return Endpoint.get<PublicResponse | PublicCategoriesResponse | PublicHelpArticlesResponse>(`@gc/public/company-data`, { params });
// }

// export function fetchPaginatedHelpArticles(params: PageQuery) {
//   return Endpoint.get<PublicHelpArticlesResponse>(`@gc/public/public-help-articles`, { params });
// }
